import {
    FileText,
    Fingerprint,
    Key,
    Layers,
    LayoutDashboard,
    MailPlus,
    Puzzle,
    Share2,
    ShieldCheck,
    ShieldHalf,
    Building2,
    User,
    Users,
    Webhook,
} from 'lucide-react';

/**
 * One icon per entity, everywhere: sidebar, page headers, table rows, dashboard and
 * drill links. Import from here instead of picking a lucide icon locally, so "Roles"
 * never shows a different shield in the list than in the navigation.
 */
const ENTITY_ICONS = {
    dashboard: LayoutDashboard,
    apps: Layers,
    users: User,
    groups: Users,
    tenants: Building2,
    invitations: MailPlus,
    roles: ShieldHalf,
    components: Puzzle,
    delegations: Share2,
    apiKeys: Key,
    webhooks: Webhook,
    sso: Fingerprint,
    auditTrail: FileText,
    portalAdmins: ShieldCheck,
};

export default ENTITY_ICONS;
